module.exports = __webpack_public_path__ + "assets/img/slogan-e973801c.png";